import React from 'react';
import img1 from '../../../Gemco-Website-Images/Clients/emaar.png';
import img2 from '../../../Gemco-Website-Images/Clients/meraas.png';
import img3 from '../../../Gemco-Website-Images/Clients/mubadala.png';
import img4 from '../../../Gemco-Website-Images/Clients/dubai_future_foundation.jpg';
import img5 from '../../../Gemco-Website-Images/Clients/alec.svg';
import img6 from '../../../Gemco-Website-Images/Clients/alemco.jpg';
import img7 from '../../../Gemco-Website-Images/Clients/futtaim.png';
import img8 from '../../../Gemco-Website-Images/Clients/dubai_airport.png';
import img9 from '../../../Gemco-Website-Images/Clients/majid_futtaim.png';
import img10 from '../../../Gemco-Website-Images/Clients/hilton.png';
import img11 from '../../../Gemco-Website-Images/Clients/accor.png';
import './Strip.css';

const Strip = () => {
  return (
    <>
    <div className='container'>
      <div className="clients">
         <h1>CLIENTS & CONTRACTORS</h1>
      </div>
      <div className='bs-work-wrap-strip'>
        <div className="card wp_why_card">
          <img className='clients_img' src={img1} alt="" />
        </div>
        <div className="card wp_why_card">
          <img className='clients_img' src={img2} alt="" />
        </div>
        <div className="card wp_why_card">
          <img className='clients_img' src={img3} alt="" />
        </div>
        <div className="card wp_why_card">
          <img className='clients_img' src={img4} alt="" />
        </div>
        <div className="card wp_why_card">
          <img className='clients_img' src={img5} alt="" />
        </div>
        <div className="card wp_why_card">
          <img className='clients_img' src={img6} alt="" />
        </div>
        <div className="card wp_why_card">
          <img className='clients_img' src={img7} alt="" />
        </div>
        <div className="card wp_why_card">
          <img className='clients_img' src={img8} alt="" />
        </div>
        <div className="card wp_why_card">
          <img className='clients_img' src={img9} alt="" />
        </div>
        <div className="card wp_why_card">
          <img className='clients_img' src={img10} alt="" />
        </div>
        <div className="card wp_why_card">
          <img className='clients_img' src={img11} alt="" />
        </div>
      </div>
      </div>
    </>
  )
}

export default Strip